import React, { useState, useEffect } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { GetReportCategories } from '../../../api/reports';
import { useQuery } from '@tanstack/react-query';

function CategoriesSelection(props) {
  const [categories, setCategories] = useState([]);
  const getCategories = useQuery({
    queryKey: ['getCategories', props.producerID],
    queryFn: () => GetReportCategories()(),
  });

  useEffect(() => {
    if (getCategories.isSuccess && getCategories.data) {
      const parsed =
        typeof getCategories.data === 'string'
          ? JSON.parse(getCategories.data)
          : getCategories.data;
      setCategories(Array.isArray(parsed) ? parsed : []);
      props.setCategory('0');
    }
  }, [getCategories.isSuccess, getCategories.data]);

  /* const getCategories = () =>{
        const body = {
            ProducerID: props.producerID
        }
        const options = {
            crossDomain: true,
            method: 'POST',
            headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        }

        fetch('/Reports/getReportCategories', options) 
            .then(res => res.json())
            .then(data => {
                setCategories(JSON.parse(data));
                props.setCategory("0");
                setLoading(false);
            })
    }*/

  const handleCategoryChange = (event) => {
    props.setCategory(event.target.value);
  };

  /*useEffect(() => {
        getCategories();
    }, []);*/

  return (
    <div className="w-100">
      {getCategories.isPending ? (
        <div id="category-select">loading...</div>
      ) : (
        <div id="category-select">
          <FormControl className="reports__category-form-control" fullWidth>
            <InputLabel>Report Category</InputLabel>
            <Select id="category-select" onChange={handleCategoryChange} defaultValue="0">
              {categories.map((category) => (
                <MenuItem key={category.CategoryName} value={category.CategoryID}>
                  {category.CategoryName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      )}
    </div>
  );
}

export { CategoriesSelection };
